import {s, lazy, trigger, filter} from './lang.js';
import {doc} from './documentation.js';
import Tone from 'tone';

const DUR_32N = new Tone.Time('32n').toSeconds();
doc(
    "stretch", 
    {
        amount: "Amount we wish to stretch notes"
    },
    "Streches patterns so they take longer to complete",
);

export const stretch = (amt=1) => {
    let mem = {};
    return (stepData, stepNumber, time, effect) => {
        let track = effect.track;
        let len = track.length;
        let _amt = lazy(amt, stepData, stepNumber, time, effect);
        if (_amt === 1) {
            return trigger({stepData, stepNumber, time});
        };
        // otherwise map the stepNumber baed on the stretch amount
        let _stepNumber = stepNumber * _amt;
        let currentTime = effect.currentTime;
        let timeOffset = (time - currentTime);
        if (stepData) {
            let off = (_stepNumber - Math.floor(_stepNumber)) * DUR_32N;
            mem[Math.floor(_stepNumber)] = {
                stepData,
                time: timeOffset + off,
            };
        }

        // now check for any stored triggers to return
        if (mem[stepNumber]) {
            let ret = trigger({
                ...mem[stepNumber],
                stepNumber: stepNumber,
                time: time + mem[stepNumber].time
            });
            delete mem[stepNumber];
            return ret;
        }
        return trigger({stepNumber, time});
    };
};
 
